import React from 'react';
import axios from "axios";
import config from "../../../config/config";
import {translate} from 'react-i18next';
import {Redirect} from 'react-router';
import PageHeader from "../../../components/elements/PageHeader";

class SupporterByBft extends React.Component {
    state = {
        result: null,
        supporterId: null,
        error: false
    };

    componentDidMount() {
        let token = this.props.match.params.token;
        if (token) {
            this.searchSupporterByBFTToken(token)
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps && nextProps.match && nextProps.match.params) {
            let token = nextProps.match.params.token;
            if (token) {
                this.searchSupporterByBFTToken(token)
            }
        }
    }

    searchSupporterByBFTToken = (token) => {
        this.setState({error: false, result: null, supporterId: null});
        axios(config.server.endpoint + 'backend/supporter/bft/' + token, {
            method: 'get'
        }).then((response) => {
            if (response.status === 200) {
                if (response.data.success === true) {
                    if (response.data.data && response.data.data.supporter && response.data.data.supporter.id) {
                        this.setState({
                            result: 'found',
                            supporterId: response.data.data.supporter.id
                        });
                    } else {
                        this.setState({
                            result: 'not_found'
                        })
                    }
                } else {
                    this.setState({error: true});
                }
            }
        }).catch(() => {
            this.setState({error: true});
        });
    };

    render() {
        const {result, error, supporterId} = this.state;
        const {t} = this.props;
        return (
            <div className="SupporterByBft">
                <PageHeader title={`${t('supporterByBft.title')}${this.props.match.params.token ? (': ' + this.props.match.params.token) : ''}`}/>
                <div className="row m-t m-b">
                    <div className="col-xs-12">
                        {error ? (
                            <div className="panel panel-danger">
                                <div className="panel-body">
                                    {t('supporterByBft.error')}
                                </div>
                            </div>
                        ) : (!result ? (
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <i className="fa fa-spinner fa-spin m-r-sm"/>
                                    {t('supporterByBft.loading')}...
                                </div>
                            </div>
                        ) : (
                            result === 'found' ? (
                                <div><Redirect to={`/supporter/${supporterId}`}/></div>
                            ) : (
                                <div className="panel panel-default">
                                    <div className="panel-body">
                                        {t('supporterByBft.notFound')}
                                    </div>
                                </div>
                            )))
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default translate()(SupporterByBft);
